import React from 'react'
import { HiOutlineSquares2X2, HiOutlineClipboardDocumentList, HiOutlineMapPin, HiArrowLeftOnRectangle, HiOutlineKey } from 'react-icons/hi2';
import { FaWpforms } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';
import LogoComponent from './LogoComponent';
import { Link, useLocation, useNavigate } from "react-router-dom"
import ROUTES, { ROUTESGROUP } from '../../application/utils/Routes';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logUserOut } from '../../application/store/actions/user';
import { getLoggedInUser } from '../../application/store/selectors/user';
import { useAuthentication } from '../../application/hooks';


function SideBar() {

    useAuthentication();
    const location = useLocation();

    const navigate = useNavigate();


    const user = useSelector(getLoggedInUser)

    const dispatch = useDispatch();

    const sidebarLinks = [
        {
            title: "Dashboard",
            url: ROUTES.DASHBOARD,
            icon: <HiOutlineSquares2X2 />,
            routeGroup: null

        },
        {
            title: "Forms",
            url: ROUTES.FORMS,
            icon: <FaWpforms />,
            routeGroup: ROUTESGROUP.FORMS
        },
        {
            title: "Admins",
            url: ROUTES.ADMINS,
            icon: <FiUsers />,
            routeGroup: ROUTESGROUP.ADMINS,
            roles: ["superadmin"]

        },
        {
            title: "Agents",
            url: ROUTES.AGENTS,
            icon: <FiUsers />,
            routeGroup: ROUTESGROUP.AGENTS

        },
        {
            title: "Responses",
            url: ROUTES.RESPONSES,
            icon: <HiOutlineClipboardDocumentList />,
            routeGroup: null
        },
        {
            title: "Maps",
            url: ROUTES.MAPS,
            icon: <HiOutlineMapPin />,
            routeGroup: null
        },
    ];

    const activeStyle = "bg-themeGreen hover:bg-themeGreenDeep text-white";
    const inActiveStyle = "text-slate-800 hover:bg-slate-100";

    const isLinkActive = (link) => {

        if (link.routeGroup !== null) return link.routeGroup.includes(location.pathname);

        return link.url == location.pathname;
    }

    return (
        <div className="p-3 pt-7">
            <LogoComponent />
            <div className="pt-7">
                <div className="flex flex-col gap-7 ">
                    {sidebarLinks.filter(s => s.roles == undefined || s.roles.includes(user.role.toLowerCase())).map(link =>

                        <Link key={link.title} to={link.url}
                            className={`p-3 rounded-md flex items-center gap-5 ${isLinkActive(link) ? activeStyle : inActiveStyle} `}>
                            {link.icon}
                            <span className="flex-1 tracking-wider">{link.title}</span>
                        </Link>)}

                    <div className={`p-3 rounded-md flex items-center gap-5 ${location.pathname ==ROUTES.CHANGEPASSWORD ? activeStyle : inActiveStyle} `} onClick={() => {
                        navigate(ROUTES.CHANGEPASSWORD)
                    }}>
                        <HiOutlineKey />
                        <span className="flex-1 tracking-wider">Change Password</span>
                    </div>

                    <div className='p-3 rounded-md flex items-center gap-5p-3 gap-5 cursor-pointer text-slate-800 hover:bg-slate-100' onClick={() => {
                        dispatch(logUserOut())
                    }}>
                        <HiArrowLeftOnRectangle />
                        <span className="flex-1 tracking-wider">Logout</span>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default SideBar